export default "__VITE_ASSET__YTAMmW$6__"